module.exports = __webpack_public_path__ + "img/2.5d8cd9da.jpg";